<template>
  <section class="content">
    <div class="row center-block">
      <box title="">
        <div slot="body">
          <div class="row">
            <div class="col-sm-3">
              <h4>Escolha o tipo de relatório:</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <select class="form-control" id="exampleFormControlSelect1" v-model="tipoRelatorio">
                  <option value="regiao">Por região (bairro)</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <p class="text-center" style="font-size:17px">
                <strong>Bairros</strong><br>
                As regiões onde mais efetuam pedidos
              </p>
              <canvas id="regioesPreferidas"></canvas>
            </div>
            <div class="col-sm-6">
              <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                <div class="row">
                  <div class="col-sm-6">
                    <div id="example1_length" class="dataTables_length"></div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table aria-describedby="example1_info" role="grid" id="example1"
                      class="table table-borde#F48668 table-striped dataTable">
                      <thead>
                        <tr>
                          <th v-for="coluna in colunas">
                            <a href="javascript:;" @click="orderPedidos(coluna.json)">
                              <div class="row">
                                <div class="col-sm-7">
                                  {{coluna | ucwords}}
                                </div>
                              </div>
                            </a>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="enderecos.length === 0">
                          <td colspan="12">Nenhum Pedido Localizado</td>
                        </tr>
                        <tr v-else class="even" role="row" v-for="(p, index) in enderecos">
                          <td>{{p.bairro | upperCase}}</td>
                          <td>{{p.qtde}}</td>
                          <!-- <td style="text-align: center;">
                            <a title="Ver Pedido" class="iconPed" href="javascript:;"
                              @click="itens(index, p.id,  p.cliente.nome, p.cliente.contato, p.cliente, p.desconto)"
                              data-toggle="modal" data-target="#modalLarge"><i class="fa fa-search"
                                aria-hidden="true"></i></a>
                          </td> -->
                        </tr>
                      </tbody>
                      <tfoot>
                        <!-- <tr>
                            <th v-for="coluna in colunas">
                                <a href="javascript:;" @click="orderPedidos(coluna.json)">{{coluna.name | ucwords}}</a>
                            </th>
                        </tr> -->
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </box>
    </div>
  </section>
</template>

<script>
  import Box from '../Box'
  import axios from 'axios'

  export default {
    name: 'Relatórios',
    components: {
      'box': Box,
    },
    data() {
      return {
        tipoRelatorio: 'regiao',
        pedidos: [],
        colunas: ['Bairro', 'Quantidade'],
        enderecos: [],
        labelTags: [],
        qtdeTags: []
      }
    },
    created() {
      this.getPedido();
    },
    methods: {
      orderPedidos(coluna) {
        if (coluna !== 'observacao') {
          this.order.keys = coluna
          this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc'
        }
      },
      getPedido() {
        axios.get(`${this.$store.state.api}pedidos/endereco?empresa=${this.$store.state.empresa_fb_id}`).then(
          response => {
            this.pedidos = response.data
            this.ajusteEndereco()
          })
      },
      ajusteEndereco() {
        for (let i = 0; i < this.pedidos.length; i++) {
          let bairro = ((this.pedidos[i].bairro.replace(/ /g, '')).normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
            .toLowerCase()
          console.log('bairro => ', bairro);

          if (this.enderecos.length > 0) {
            let adicionou = false;
            for (let j = 0; j < this.enderecos.length; j++) {
              if (this.enderecos[j].key === bairro) {
                this.enderecos[j].qtde++;
                adicionou = true;
                console.log('somou mais um no bairro ', bairro)
                break;
              }
            };
            if (!adicionou) {
              console.log('primeiro do bairro ', bairro)
              this.enderecos.push({
                bairro: this.pedidos[i].bairro,
                qtde: 1,
                key: bairro
              })
            }
          } else {
            console.log('endereços vazio, iniciou com ', bairro)
            this.enderecos.push({
              bairro: this.pedidos[i].bairro,
              qtde: 1,
              key: bairro
            })
          }
          // console.log('end => ', this.enderecos)

          // this.enderecos[bairro] ? this.enderecos[bairro].qtde = this.enderecos[bairro].qtde + 1 : this.enderecos[bairro] = { bairro: element.bairro, qtde: 1 }
        };
        this.enderecos.sort(function(a,b) {
          return a.qtde > b.qtde ? -1 : a.qtde < b.qtde ? 1 : 0;
        });
        console.log('enderecos => ', this.enderecos)
        this.getRegioesPreferidas()
      },
      getRegioesPreferidas() {
        for (var i = 0; i < 4; i++) {
          this.labelTags.push(this.enderecos[i].bairro)
          this.qtdeTags.push(this.enderecos[i].qtde)
        }
        console.log('tags => ', this.labelTags)
        console.log('qtde => ', this.qtdeTags)
        var pieChartCanvas = document.getElementById('regioesPreferidas').getContext('2d')
        var pieConfig = {
          type: 'bar',
          data: {
            labels: this.labelTags,
            datasets: [{
              data: this.qtdeTags,
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef', '#FF937D', '#9CFFDD'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef', '#FF937D', '#9CFFDD']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: false
            },
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            }
          }
        }
        new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
      },
    },
    computed: {
      pedidosFiltered() {
        console.log('keys => ', Object.keys(this.enderecos))
        return []
      }
    },
    filters: {
      ucwords(value) {
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// Relatorios.vue?8c81f5d6